import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import FooterLogo from "../web_elements/footer_logo.webp";
import ProducersLogo from "../web_elements/stati_and_abudi_signature_logo.png";
import '../styles/Footer.css';
export default function AnimatedEndLogo() {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: 0.5, // 50% visible triggers
        triggerOnce: false,
    });

    useEffect(() => {
        if (inView) {
            controls.start({ x: 0, opacity: 1 });
        } else {
            controls.start({ x: "-100vw", opacity: 0 });
        }
    }, [inView, controls]);
    const animationsSecs = 1.75;
    return (
        <div>
            <motion.div class="end-logos" id="espobuilt-logo"
                ref={ref}
                initial={{ x: "-300px", opacity: 0 }}
                        threshold={0.5}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ margin: "200px" }}
                transition={{ duration: animationsSecs, ease: "easeInOut" }}
            >
                <img className="end-logo" id="footer-logo"
                     src={FooterLogo}
                     alt="footerLogo">
                </img>
                </motion.div>
            <motion.div class="end-logos" id="producers-logo"
                        initial={{ x: "-300px", opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ margin: "200px" }}
                        transition={{ duration: animationsSecs, ease: "easeInOut" }}
                        >
                <img className="end-logo" id="producers-logo"
                     src={ProducersLogo}
                     alt="producers-logo">
                </img>
            </motion.div>
        </div>
    );
}